import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import {provideTranslateService, TranslateLoader, TranslateModule} from "@ngx-translate/core";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { provideToastr } from 'ngx-toastr';


export function HttpLoaderFactory(httpClient: HttpClient) {   
  return new TranslateHttpLoader(httpClient, environment.LANGUAGES_FILE_PATH, '.json');

  // const host = window.location.hostname === '54.83.175.65' ? 'development' : 'production';
  // if (host === Server.DEVELOPMENT) {
  //   return new TranslateHttpLoader(httpClient,'aoc-token-locker'+environment.LANGUAGES_FILE_PATH,'.json');
  // } else {
  //   return new TranslateHttpLoader(httpClient,environment.LANGUAGES_FILE_PATH,'.json');
  // }
}

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes),
    provideTranslateService({
      defaultLanguage: 'en'
     }),
     provideHttpClient(),
     importProvidersFrom(
      BrowserAnimationsModule,
      NgxSpinnerModule,
     TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ),
    provideAnimations(),
    provideToastr(),
  ]
};


export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}